import { connect } from 'react-redux';
import * as categoriesActions from '../../redux/actions/categoriesActions';

export default (WrappedComponent) => connect(null, categoriesActions)(WrappedComponent);
